export { default } from './useTimeout';
export { Timeout } from './useTimeout';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useTimeout/index.js
// module id = 163
// module chunks = 22